import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  containerDateCity: {
    paddingHorizontal: 10,
    marginVertical: 30,
    fontSize: 15,
  },
  dateCityText: {
    fontSize: 12,
  },
});
